import {
	ChangeDetectionStrategy,
	Component,
	Inject,
	OnInit,
	signal,
} from '@angular/core';
import { ModalService } from '@ui/modal/modal.service';
import { MODAL_DATA } from '@ui/modal/modal-data.token';
import { ICON } from '@core/util/icon';
import { FormControl, FormGroup, Validators } from '@angular/forms';
import { MatterDispatch } from '@state/matter';
import { ToastService } from '@ui/toast/toast.service';
import { Store } from '@ngxs/store';
import { Logger } from '@core/logger';
import { take } from 'rxjs';

@Component({
	selector: 'app-title-insurance-price-override-modal',
	templateUrl: './title-insurance-price-override-modal.component.html',
	changeDetection: ChangeDetectionStrategy.OnPush,
	standalone: false,
})
export class TitleInsurancePriceOverrideModalComponent implements OnInit {
	public ICON = ICON;
	form: FormGroup;
	submitted_ = signal(false);
	placeholder: number;

	constructor(
		private modalService: ModalService,
		@Inject(MODAL_DATA)
		private data: {
			matterId: string;
			price: number;
			priceOverride: number | null;
		},
		private matterDispatch: MatterDispatch,
		private toastService: ToastService,
		private store: Store,
	) {}

	ngOnInit(): void {
		this.placeholder = this.data?.price;

		this.form = new FormGroup({
			purchasePriceOverrideTitleInsurance: new FormControl(
				this.data?.priceOverride,
				[Validators.required, Validators.min(1)],
			),
		});
	}

	close(): void {
		this.modalService.closeModal();
	}

	onSubmit(): void {
		if (this.form.invalid) return;

		this.submitted_.set(true);

		this.store
			.dispatch(
				this.matterDispatch.SetPurchasePriceOverrideTitleInsurance(
					this.data?.matterId,
					this.form.controls.purchasePriceOverrideTitleInsurance.value,
				),
			)
			.pipe(take(1))
			.subscribe({
				next: () => {
					this.close();
					this.submitted_.set(false);
					this.toastService.success(
						'Purchase price has been updated successfully.',
					);
				},
				error: (err) => {
					this.submitted_.set(false);
					const errorMessage =
						'Failed to update purchase price (title insurance only).';
					this.toastService.error(errorMessage);
					Logger.error(`${errorMessage}: ${err}`);
				},
			});
	}
}
